export class CardExpFormatter {
    current: string;
    prev: string | null;

    constructor() {
        this.current = "";
        this.prev = null;
    }

    setValue(val: string, character: string = ""): void {
        this.prev = this.current;
        this.current = val + character;
    }

    format(val: string): string {
        const maxLength = 7;
        const barPosition = 2;
        const splittedDate: string[] = val.split("/");
        const month = splittedDate[0];
        let fullValueIsNotString = true;

        if (val.length === 3) {
            val = val.replace(/[&\\\#,+()$~%.'":*?<>{}]/g, '/');
        } else {
            val = val.replace(/[&\\\#,+()$~%.'":*?<>{}]/g, '');
        }
        
        for (const i in splittedDate) {
            const date = splittedDate[i];
            const lastIteration = Number(i) === splittedDate.length - 1;
            const dateIsNumber = !isNaN(Number(date));

            if ((dateIsNumber && fullValueIsNotString) && Number(month) < 13) {
                if (month === "00") {
                    return this.current;
                }

                if (lastIteration) {
                    if ((val.length === barPosition && this.prev.length < val.length)) {
                        this.setValue(val, "/");
                    } else {
                        this.setValue(val);
                    }
                    
                    // TODO: Analyze this 
                    if (this.current.length === maxLength + 1) {
                        this.setValue(val.substring(0, this.current.length - 1));
                    }
                }
            } else {
                fullValueIsNotString = false;
                
                this.prev = this.current;
                this.current = val.substring(0, val.length - 1);
            }
        }
        
        return this.current;
    }
}